/* eslint-disable max-len */
import { useReducer, useCallback } from 'react';
import { MediaState, MediaAction } from '../types';

// Initial media state
export const initialMediaState: MediaState = {
	hasThumbnail    : false,
	thumbnailUrl    : undefined,
	thumbnailSource : undefined,
	thumbnailKey    : undefined
};

// Media reducer function
const mediaReducer = (state: MediaState, action: MediaAction): MediaState =>
{
	switch (action.type)
	{
		case 'UPDATE_THUMBNAIL':
			return {
				...state,
				hasThumbnail    : action.payload.hasThumbnail,
				thumbnailUrl    : action.payload.thumbnailUrl,
				thumbnailSource : action.payload.thumbnailSource,
				thumbnailKey    : action.payload.thumbnailKey
			};
		case 'RESET_MEDIA':
			return initialMediaState;
		default:
			return state;
	}
};

export const useMediaState = (category?: any) =>
{
	const initialState = category?.thumbnailUrl
		? {
			hasThumbnail    : true,
			thumbnailUrl    : category.thumbnailUrl,
			thumbnailSource : category.thumbnailSource || 'system',
			thumbnailKey    : category.thumbnailKey
		}
		: initialMediaState;

	const [ mediaState, dispatchMedia ] = useReducer(mediaReducer, initialState);

	const handleMediaUpdate = useCallback((thumbnailUrl?: string, thumbnailSource?: string, thumbnailKey?: string) =>
	{
		dispatchMedia({
			type    : 'UPDATE_THUMBNAIL',
			payload : {
				hasThumbnail    : Boolean(thumbnailUrl),
				thumbnailUrl,
				thumbnailSource, // Keep exactly as passed - could be undefined
				thumbnailKey
			}
		});
	}, []);

	return {
		mediaState,
		dispatchMedia,
		handleMediaUpdate
	};
};